import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetsComponent } from './components/widgets/widgets.component';
import { OutmodelComponent } from './components/outmodel/outmodel.component';
import { ReactiveFormsModule } from '@angular/forms';
import { PaceCoreModule } from '../pace-core.module';
// TODO to be moved to pace-core module
@NgModule({
    declarations: [WidgetsComponent, OutmodelComponent],
    exports: [WidgetsComponent],
    imports: [CommonModule, ReactiveFormsModule, PaceCoreModule.forChild()],
})
export class WidgetsModule {}
